import React, { useReducer, useEffect, useContext } from "react";
import opdContext from "./opdContext.js";
import { getAllOPD, addOPD as addOPDApi, updateOPD as updateOPDApi, deleteOPD as deleteOPDApi } from '../../api/opd.js';
import opdReducer from "./opdReducer.js";

import { ACTUALIZAR_LIST_OPD, AGREGAR_OPD, MODIFICAR_OPD, ELIMINAR_OPD } from "./opdActions.js";

import { SocketContext } from "../socket/socket.js";
import authContext from "../authentication/authContex.js";

const OpdState = props => {

    const server = useContext(SocketContext);

    const initialState = {
        opdList: []
    };

    const [state, dispatch] = useReducer(opdReducer, initialState);
    const auContext = useContext(authContext);
    const { usuario, verificarTenant } = auContext;

    const actualizarOPDList = async () => {
        try {
            const resp = await getAllOPD();
            const opds = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_OPD,
                payload: opds
            });
            return opds;
        } catch (err) {
            console.log(err);
            return err;
        }
    };

    const agregarOPD = async (opd, products, imputaciones = [], tareas = []) => {
        try {
            const resp = await addOPDApi(opd, products, imputaciones, tareas);
            const opdCreated = resp.data.data;
            dispatch({
                type: AGREGAR_OPD,
                payload: opdCreated
            });
            return opdCreated;
        } catch (err) {
            console.log(err);
            throw err;
        }
    };

    const modificarOPD = async (id, updates, products, imputaciones = undefined, tareas = undefined) => {
        try {
            const resp = await updateOPDApi(id, updates, products, imputaciones, tareas);
            const opdUpdated = resp.data.data;
            dispatch({
                type: MODIFICAR_OPD,
                payload: opdUpdated
            });
            return opdUpdated;
        } catch (err) {
            console.log(err);
            throw err;
        }
    };

    const eliminarOPD = async (nroFor, id, state) => {
        try {
            const resp = await deleteOPDApi(nroFor, id, state);
            dispatch({
                type: ELIMINAR_OPD,
                payload: id
            });
            return resp.data.data;
        } catch (err) {
            console.log(err);
            throw err;
        }
    };

    const getOPDByID = (id) => {
        return state.opdList.find(opd => opd._id === id);
    };

    /*
        Disparadores que sincronizan la lista de OPDs ante la modificacion de uno.
    */
    useEffect(() => {
        if (server) {
            // OPD Nuevo
            server.on('addOPD', ({ tenantId }) => {
                const update = verificarTenant(tenantId);
                if (update) {
                    console.log("RealTimeServer indico que una OPD ha sido agregada, actualizando lista de OPDs...");
                    actualizarOPDList();
                }
            });

            // OPD Actualizado
            server.on('updateOPD', ({ tenantId }) => {
                const update = verificarTenant(tenantId);
                if (update) {
                    console.log("RealTimeServer indico que una OPD ha sido modificada, actualizando lista de OPDs...");
                    actualizarOPDList();
                }
            });

            // OPD Eliminado
            server.on('deleteOPD', ({ tenantId }) => {
                const update = verificarTenant(tenantId);
                if (update) {
                    console.log("RealTimeServer indico que una OPD ha sido eliminada, actualizando lista de OPDs...");
                    actualizarOPDList();
                }
            });

            return () => {
                server.off('addOPD');
                server.off('updateOPD');
                server.off('deleteOPD');
            };
        }
    }, [server]);

    useEffect(() => {
        if (usuario != null) actualizarOPDList();
    }, [usuario]);

    return (
        <opdContext.Provider
            value={{
                opdList: state.opdList,
                actualizarOPDList,
                agregarOPD,
                modificarOPD,
                eliminarOPD,
                getOPDByID
            }}
        >
            {props.children}
        </opdContext.Provider>
    )
}

export default OpdState;
